import { Button } from "@mui/material";
import { useGoogleLogin, CodeResponse } from "@react-oauth/google";
import { Icon } from "@iconify/react";

export type GoogleLoginProps = {
  onSuccess: (
    response: Omit<CodeResponse, "error" | "error_description" | "error_uri">
  ) => void;
  component?: React.ComponentType<{ onClick?: () => void }>;
  buttonLabel?: string;
};

const GoogleLogin = ({
  onSuccess,
  component: Component,
  buttonLabel,
}: GoogleLoginProps) => {
  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: onSuccess,
  });

  return (
    <>
      {Component ? (
        <Component onClick={login} />
      ) : (
        <Button
          variant="outlined"
          startIcon={<Icon icon="flat-color-icons:google" />}
          onClick={login}
        >
          {buttonLabel || "Acceder con Google"}
        </Button>
      )}
    </>
  );
};

export default GoogleLogin;
